import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private isLoading = false;
  loadingStatus: Subject<boolean> = new Subject<boolean>();

  show(): void {
    this.isLoading = true;
    this.loadingStatus.next(true);
  }

  hide(): void {
    this.isLoading = false;
    this.loadingStatus.next(false);
  }

  getStatus(): boolean {
    return this.isLoading;
  }
}
